const stripInstagramDecorations = (value = "") => {
  const cleaned = String(value || "").trim();
  if (!cleaned) return "";
  return cleaned
    .replace(/^https?:\/\//i, "")
    .replace(/^www\./i, "")
    .replace(/[?#].*$/, "")
    .replace(/\/+$/, "");
};

export const canonicalizeInstagramProfileUrl = (value = "") => {
  const normalized = stripInstagramDecorations(value);
  const match = normalized.match(/^instagram\.com\/([a-zA-Z0-9._]{1,30})$/i);
  if (!match) return "";
  return `https://www.instagram.com/${match[1]}`;
};

export const canonicalizeInstagramPostUrl = (value = "") => {
  const normalized = stripInstagramDecorations(value);
  const match = normalized.match(/^instagram\.com\/(p|reel|tv)\/([a-zA-Z0-9_-]{5,})$/i);
  if (!match) return "";
  return `https://www.instagram.com/${match[1]}/${match[2]}`;
};

export const isValidInstagramProfileUrl = (value = "") => Boolean(canonicalizeInstagramProfileUrl(value));
export const isValidInstagramPostUrl = (value = "") => Boolean(canonicalizeInstagramPostUrl(value));

export const extractInstagramUsername = (value = "") => {
  const canonical = canonicalizeInstagramProfileUrl(value);
  if (!canonical) return "";
  return canonical.split("/").pop() || "";
};

export const parseInstagramCheckResponse = async (response, fallbackMessage = "Could not verify Instagram") => {
  const contentType = response.headers.get("content-type") || "";
  const raw = await response.text();
  const trimmed = raw.trim();
  const looksLikeHtml = trimmed.startsWith("<!DOCTYPE") || trimmed.startsWith("<html") || trimmed.startsWith("<");
  const looksLikeGatewayError = /^error code:\s*\d+/i.test(trimmed);

  if (contentType.includes("application/json")) {
    try {
      const payload = raw ? JSON.parse(raw) : {};
      if (!response.ok) {
        throw new Error(payload.detail || fallbackMessage);
      }
      return payload;
    } catch (error) {
      if (error instanceof Error && error.message) {
        throw error;
      }
      throw new Error(fallbackMessage);
    }
  }

  if (!response.ok) {
    throw new Error(looksLikeHtml || looksLikeGatewayError ? fallbackMessage : (trimmed || fallbackMessage));
  }

  if (!trimmed) {
    return {};
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    throw new Error(fallbackMessage);
  }
};
